export const type = 'changeIndexAccordion'

const changeIndexAccordion = index => {
    return {
        type,
        payload: index
    }
}

export default changeIndexAccordion